import ApiServices from "@/services/uteis/ApiServices";
export default {
  namespaced: true,
  state: {
    param: {
      validacoes: {
        1: "Validar CGM",
        2: "Validar Responsável",
        3: "Validar Cargo",
        4: "Validar Direção",
        5: "Validar Magistrando",
      },
      //34173326807
      //00164152130
      //1015008080
      listQuestionario: [],
      Selecionado: {},
      anoSelecionado: null,
      listaApto: [],
      cpf: "",
      id_instituicao: "",
      pessoa: {},
      respondendo: {},
      disponivel: [],
      listaCargos: [],
      listaGrupos: [],
    },
    adminlogado: null,

    rote: {
      main: (path) => {
        let main = "/pedagogico/avaliacao-institucional";
        return `${main}${path}`;
      },
      questionario: (path = "") => {
        let main = `/ava/questionario${path}`;
        return main;
      },
      publicoQuestionario: (path = "") => {
        let main = `/ava/publico-questionario${path}`;
        return main;
      },
      questoes: (path = "") => {
        let main = `/ava/questoes${path}`;
        return main;
      },
      opcoes: (path = "") => {
        let main = `/ava/opcoes${path}`;
        return main;
      },
      processos: (path = "") => {
        let main = `/ava/processos${path}`;
        return main;
      },
      cargos: (path = "") => {
        let main = `/rh/cargos${path}`;
        return main;
      },
      gruposOpcional: (path = "") => {
        let main = `/rh/grupo-ocupacional${path}`;
        return main;
      },
    },
  },
  getters: {
    validacoes(state) {
      return state.param.validacoes;
    },
    listaGrupos(state) {
      return state.param.listaGrupos;
    },
    listaCargos(state) {
      return state.param.listaCargos;
    },
    param(state) {
      return state.param;
    },
    anoSelecionado(state) {
      return state.param.anoSelecionado;
    },
    selecionado(state) {
      return state.param.Selecionado || {};
    },
    adminlogado(state) {
      return state.adminlogado;
    },
  },
  mutations: {
    setPessoa(state, payload) {
      state.param.pessoa = payload;
    },
    setStatusEditando(state, payload) {
      state.param.statusEditando = payload;
    },
    setAdminLogado(state, payload) {
      state.adminlogado = payload;
    },
    setSelecionado(state, payload) {
      state.param.Selecionado = payload;
    },
    setAnoSelecionado(state, payload) {
      state.param.anoSelecionado = payload;
    },
    setListQuestionario(state, payload) {
      state.param.listQuestionario = payload;
    },
  },
  actions: {
    atualizarQuestionario({ state }, payload) {
      return ApiServices.put(state.rote.questionario(), payload);
    },
    // CRUD de público do questionário
    inserirPublicoQuestionario({ state }, payload) {
      return ApiServices.post(state.rote.publicoQuestionario(), payload);
    },
    editarPublicoQuestionario({ state }, { id, data }) {
      return ApiServices.put(state.rote.publicoQuestionario(`/${id}`), { data });
    },
    excluirPublicoQuestionario({ state }, id) {
      return ApiServices.delete(state.rote.publicoQuestionario(`/${id}`));
    },
    requestPublicoQuestionarioAll({ state }, payload) {
      return ApiServices.get(state.rote.main("/publicoquestionarioall"), payload);
    },

    requestQuestao({ state }, payload) {
      return ApiServices.get(state.rote.main("/questoes"), payload);
    },
    requestQuestionarios({ state }, payload) {
      return ApiServices.get(state.rote.main("/questionarios"), payload);
    },
    requestValidar({ state }, payload) {
      return ApiServices.post(state.rote.main("/validar"), payload);
    },
    requestResponder({ state }, payload) {
      state;

      return ApiServices.post(state.rote.main("/responder"), payload);
    },
    requestAdimin({ state }, payload) {
      return ApiServices.post(state.rote.main("/acessoadmin"), payload);
    },

    requestOpcoes({ state }, payload) {
      return ApiServices.get(state.rote.opcoes(), payload);
    },

    // CRUD de questões
    criarQuestao({ state }, payload) {
      return ApiServices.post(state.rote.questoes(), payload);
    },
    atualizarQuestao({ state }, payload) {
      return ApiServices.put(state.rote.questoes(), payload);
    },
    deletarQuestao({ state }, id) {
      return ApiServices.delete(state.rote.questoes(`/${id}`));
    },
    requestProcessos({ state }, payload) {
      return ApiServices.get(state.rote.processos(), payload);
    },
    async bootstrapListas({ state }) {
      try {
        // Buscar lista de cargos
        const responseCargos = await ApiServices.get(state.rote.cargos());

        state.param.listaCargos = responseCargos.data || [];
        // Buscar lista de grupos
        const responseGrupos = await ApiServices.get(state.rote.gruposOpcional());

        state.param.listaGrupos = responseGrupos.data || [];
      } catch (error) {
        console.error("Erro ao buscar listas:", error);
      }
    },
  },
};
